// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\ndiv[data-v-76584f67] {\n  height: 2.8rem;\n  width: 2.8rem;\n  display: inline-flex;\n  border-radius: 50%;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  background-color: transparent;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
